<section id="individual-investors">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1>Full Service, Faith-Consistent Investment Management</h1>
            </div>
        </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
        <div class="row">
          <div class="col-sm-12">
              <div class="icon-holder">
                  <img src="images/investment-advisory.png" height="120" alt="investment advice">
              </div>
            <h3>Investment Advice</h3>
            <p>IFC provides investment advisory services that focus specifically on matching people with portfolios of passively managed or index mutual funds, based on the client's risk capacity.</p>
          </div>
          <div class="col-sm-6">
            <ul>
              <li>Identification of Individual Risk Capacity</li>
              <li>Development of Optimal Asset Allocation</li>
              <li>Selection & Monitoring of Investments</li>
              <li>Performance Monitoring Reports</li>
              <li>Behavioral Finance Advice</li>
              <li>Independent & Fiduciary Based Advice</li>
              <li>Rebalancing Advice</li>
            </ul>
          </div>
          <div class="col-sm-6">
              <ul>
                <li>Tax Loss Harvesting</li>
                <li>Tax Management & Asset Location Strategies</li>
                <li>Performance Reports from Date of Inception</li>
                <li>Glide Path Systematic Risk Reduction Program</li>
                <li>Cash Withdrawal & Deposit Management</li>
                <li>Alternative Investment Evaluations</li>
              </ul>
            </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="row">
            <div class="col-sm-12">
                <div class="icon-holder">
                    <img src="images/financial-planning.png" height="120" alt="financial planning">
                </div>
                <h3>Financial Planning</h3>
                <p>IFC Wealth Advisors utilize third-party financial planning software to produce comprehensive financial plans for clients. The analysis provides the foundation for recommendations to achieve each client's financial objectives.</p>
              </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="row">
            <div class="col-sm-12">
                <div class="icon-holder">
                    <img src="images/retirement-planning.png" height="120" alt="retirement planning">
                </div>
                <h3>Retirement Planning</h3>
                <p><!--With the aid of the IFC Retirement Plan Analyzer,--> IFC Wealth Advisors are able to help clients make more informed decisions in each stage of retirement.</p>
              </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="row">
            <div class="col-sm-12">
                <h3 class="mb-5">Additional Services</h3>

                <div class="icon-holder-small">
                    <img src="images/estate-planning.png" height="90" alt="estate planning">
                </div>
                <h5>Estate Planning Services</h5>
                <p>IFC Wealth Advisors can refer clients to estate planning attorneys to create estate plans and aid in the implementation of the plans.</p>

                <div class="clearfix mb-5"></div>

                <div class="icon-holder-small">
                    <img src="images/trustee.png" height="90" alt="trustee services">
                </div>
                <h5 class="mt-4">Trustee Services</h5>
                <p>For trust management and administrative needs, IFC Wealth Advisors can refer clients to corporate or administrative trustees through Schwab, National Advisors Trust or Fidelity.</p>

                <div class="clearfix mb-5"></div>

                <div class="icon-holder-small">
                    <img src="images/insurance.png" height="90" alt="insurance services">
                </div>

                <h5 class="mt-4">Insurance Services</h5>
                <p>IFC Wealth Advisors refer clients to insurance advisors and collaborate with the advisors to integrate the insurance policies with the overall financial needs of the client.</p>

                <div class="clearfix mb-5"></div>

                <div class="icon-holder-small">
                    <img src="images/charitable-giving.png" height="90" alt="charitable giving">
                </div>

                <h5 class="mt-4">Charitable Giving Services</h5>
                <p>IFC Wealth Advisors assist clients in setting up donor advised funds, which are charitable giving accounts that provide an efficient way to make grants to charities.</p>

                <div class="clearfix mb-5"></div>

                <div class="icon-holder-small">
                    <img src="images/social-security-optimization.png" height="90" alt="social security optimization">
                </div>

                <h5 class="mt-4">Social Security Optimization Services</h5>
                <p>IFC Wealth Advisors and expert resources provide a powerful solution to determine how to maximize your social security benefits and further outline your complete financial picture.</p>
              </div>
        </div>
      </div>
  </section>